import axios from "@/utils/axios.js"

export default axios
